import React, {Fragment, useEffect, useState} from 'react';
import { AiFillSave } from 'react-icons/ai';
import Breadcumb from '../Common/Breadcumb';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { errorToast, isEmpty } from '../../helper/FormHelper';
import store from '../../../redux/store/store';
import { onChangeCategoryFormInput,resetCategoryFormValue,toggleManageSubcategory } from '../../../redux/slice/admin/CategorySlice';
import { CategoryCreateApiService,FillCategoryFormRequest,GetMeasurementTypeList } from '../../apiServices/CategoryApiService';

const CategoryCreate = () => {
    let navigate=useNavigate();
    let formValue=useSelector((state)=>(state.categorySlice.formValue));
    let [rowRd,setRowID]=useState(0);
    
    useEffect(()=>{
        (async () => {
            await GetMeasurementTypeList();
        })();
        store.dispatch(resetCategoryFormValue())
        let params= new URLSearchParams(window.location.search);
        let id=params.get('id');

        if(id!==null){
            setRowID(id);
            (async () => {
                await FillCategoryFormRequest(id);
            })();
        }else{
            setRowID(0);
        }
        
    },[])

    let measurementTypeList=useSelector((state)=>(state.categorySlice.measurementTypeList.data));

    const saveChange =  async() => {
        if(isEmpty(formValue.name)){
            errorToast("Name Required !")
        }else if(isEmpty(formValue.measurement_type_id)){
            errorToast("Measurement Type Required !")
        }else {
            console.log(formValue)
            if(await CategoryCreateApiService(formValue,rowRd)){
                navigate("/category/list")
            }
        }
    }

    
    const breadcumb={
        dashboard:"Dashboard",
        menu:"Account",
        link:"/warehouse/list",
        feature:rowRd !==0?"Update Warehouse":"Create Warehouse"
    }
    const isNameValid = true;
    const isMeasurementTypeValid = true;


    
    

    return (
        <Fragment>
            <div className="container-fluid mt-5">
                <Breadcumb breadcumb={breadcumb}></Breadcumb>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card admin-card">
                            <div class="card-header card-header-custom mb-2">
                                <h5 class="mb-0">{breadcumb.feature}</h5>
                            </div>
                            <div className="card-body">    


                                <div class="row mt-2">
                                    <div class="col-lg-6">
                                        
                                            <div class="row form-row">
                                                <label for="email" className="col-lg-3 col-form-label text-title-field required">Name</label>
                                                <div class="col-lg-9">
                                                <input className={`form-control admin-form-control ${
                                                !isNameValid ? 'is-invalid' : '' }`} placeholder="name" onChange={(e)=>{store.dispatch(onChangeCategoryFormInput({name:"name",value:e.target.value}))}} value={formValue.name} type="text" />
                                            {!isNameValid && ( 
                                                <div className="invalid-feedback">Name is required.</div>
                                            )}
                                                </div>
                                                
                                            </div>
                                       
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="row form-row">
                                            <label for="email" className="col-lg-3 col-form-label text-title-field required">Measurement Type</label>
                                            <div class="col-lg-9">
                                            <select onChange={(e)=>{store.dispatch(onChangeCategoryFormInput({name:"measurement_type_id",value:e.target.value}))}} className={`form-control admin-form-control ${
                                            !isMeasurementTypeValid ? 'is-invalid' : '' }`}>
                                        <option value="">Choose One</option>
                                        {
                                            measurementTypeList?.map(item=>
                                                <option  key={item.id} selected={formValue.measurement_type_id===item.id} value={item.id}>{item.name}</option>
                                            )
                                        }
                                        
                                       
                                    </select>
                                    
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>

                               
                                <div class="row mt-2">
                                    <div class="col-lg-6">
                                        <div class="form-group col-12">
                                        <input class="form-check-input" type="checkbox" value="1" 
                                            checked={formValue.manage_subcategory}
                                            onChange={(e)=>{store.dispatch(toggleManageSubcategory({name:"manage_subcategory"}))}} />
                                            <label class="form-check-label" for="flexCheckChecked">
                                            Manage subcategory for this category type
                                            </label>   
                                       
                                            
                                        </div>
                                    </div>
                                    
                                </div>
                               
                                <div className="row mt-4">
                                    <div className="col-12 d-flex justify-content-end">
                                        <button onClick={saveChange} className="btn  btn-success admin-btn ">
                                        <AiFillSave></AiFillSave> Save</button>
                                    </div>
                                </div>
                               
                                
                               
                               
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        </Fragment>
    );
};

export default CategoryCreate;